import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** Заголовок страницы с действиями справа. */
export function PageHeader({
  title,
  description,
  actions,
  className,
}: {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-wrap items-start justify-between gap-3 border-b border-border/40 px-6 py-4',
        className,
      )}
    >
      <div className="min-w-0">
        <h1 className="text-lg leading-tight font-semibold">{title}</h1>
        {description ? (
          <div className="mt-1 text-sm text-muted-foreground">{description}</div>
        ) : null}
      </div>
      {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
    </div>
  );
}

/** Содержимое страницы под заголовком. */
export function PageBody({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('px-6 py-5', className)}>{children}</div>;
}
